import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const saveRiskTolerance = createAsyncThunk(
	'user/saveRiskTolerance',
	async (body: { value: string }, { rejectWithValue }) => {
		try {
			await AccountService.saveRiskTolerance(body);
			return AccountService.profile();
		} catch (e: any) {
			return rejectWithValue(e?.response.data);
		}
	},
);
